import { render, staticRenderFns } from "./Approval-List.vue?vue&type=template&id=6833dc66&scoped=true&"
import script from "./Approval-List.vue?vue&type=script&lang=js&"
export * from "./Approval-List.vue?vue&type=script&lang=js&"
import style0 from "./Approval-List.vue?vue&type=style&index=0&id=6833dc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833dc66",
  null
  
)

export default component.exports